import {Typography} from '@sollapay/ui';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

/** "(me)" after the signed-in user's name. */
export const ShareCurrentUserLabel: FC = () => {
  const {t} = useTranslation('trustAccounts');

  return (
    <Typography size="sm" color="tertiary" className="shrink-0">
      {t('share.me')}
    </Typography>
  );
};
